import { useQuery } from "@tanstack/react-query";
import galleriesMediaAPI from "../../api/galleries-media/api";

export function getQueryKey(galleryId: string | number) {
  return ["galleries-media", "gallery", galleryId];
}

export function useGetGalleriesMediaByGalleryId(galleryId: string | number) {
  return useQuery({
    queryKey: getQueryKey(galleryId),
    queryFn: () => galleriesMediaAPI.getGalleriesMediaByGalleryId(galleryId),
    enabled: !!galleryId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
